module.exports = __webpack_public_path__ + "img/home_banner1.ea79a82b.jpg";